import { Map } from 'immutable';
import { pathSubscription, subscription } from 'nike-re-framejs';

export const accountNewMessages$ = pathSubscription(['account', 'newMessages'], 0);
export const accountMessages$ = subscription(db => db.getIn(['account', 'messages'], new Map()).valueSeq());
export const accountMessage$ = id => pathSubscription(['account', 'messages', id]);
export const accountMessageLoading$ = pathSubscription(['account', 'messageLoading']);
